import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/zoom';
import { FreeMode, Navigation, Thumbs, Controller, Zoom, Mousewheel, Lazy } from 'swiper';
// import { extract_main_file_images as images } from './extract_files';
import { FloatingLabel, Form, Modal, Spinner } from 'react-bootstrap';

import './css/pdf-image-swiper.scss';
import { useDispatch } from 'react-redux';
import { fetchEbookPages, fetchEbookPagesCount } from '../../../Store/actions/ebook.action';
import { toast } from 'react-toastify';

const BaseLimit = 10;
export default function ImageSwiper({ ebookId = 0 }) {
  const googleStorageBaseUrl = 'https://storage.googleapis.com/';
  const [thumbsSwiper, setThumbsSwiper] = useState();
  const swiper1Ref = useRef(null);

  const swiper2Ref = useRef();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleExpansion = () => setIsSidebarOpen((prev) => !prev);
  const [currentPage, setCurrentPage] = useState(1);
  const [pdfImages, setPdfImages] = useState([]);
  const [lastPageFetched, setLastPageFetched] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();

  const fetchPdfPages = (offset, limit, callback) => {
    setIsLoading(true);
    const startIndex = offset;
    const endIndex = startIndex + limit;
    dispatch(
      fetchEbookPages(ebookId, startIndex, limit, (response) => {
        if (response == 'error') {
          setIsLoading(false);
          return;
        }
        let responseImages = response?.data ?? [];
        let tempImages =
          responseImages?.length > 0
            ? responseImages.filter((img) => {
                //check the page_no is present in pdfImages already
                return !pdfImages.some((pdfImage) => pdfImage.page_no == img.page_no);
              })
            : [];
        if (tempImages && tempImages.length > 0) {
          setPdfImages((prev) => {
            return [...prev, ...tempImages];
          });
          setLastPageFetched(endIndex);
          setIsLoading(false);
          callback && callback(tempImages, endIndex);
        } else {
          setIsLoading(false);
        }
      })
    );
  };

  useLayoutEffect(() => {
    if (swiper1Ref?.current && swiper2Ref?.current) {
      swiper1Ref.current.controller.control = swiper2Ref.current;
    }
  }, [swiper1Ref.current, swiper2Ref.current]);

  useEffect(() => {
    //fetch first 20 pages
    dispatch(
      fetchEbookPagesCount(ebookId, (response) => {
        if (response == 'error') {
          return;
        }
        let count = response?.data;
        if (count && parseInt(count) && parseInt(count) > 0) {
          setTotalCount(parseInt(count));

          fetchPdfPages(0, BaseLimit);
        } else {
          setIsLoading(false);
        }
      })
    );
  }, []);

  // effect of currentPage, if currentPage == lastPageFetched - 5, fetch next 20 pages
  useEffect(() => {
    console.log('lastPageFetched: ', lastPageFetched);
    console.log('currentPage: ', currentPage);
    if (lastPageFetched > 0 && currentPage === lastPageFetched - 5) {
      fetchPdfPages(lastPageFetched, BaseLimit);
    }
  }, [currentPage, lastPageFetched]);
  const handlePageChange = (page = 0) => {
    let index = page ? parseInt(page) : 0;

    console.log('index starting of function : ', index);
    if (index > 0) {
      if (index > totalCount) {
        toast.error('Please enter a valid number!');
        // index = totalCount;
        return false;
      }
      // if index >= lastPageFetched then fetch next 20 pages
      if (index >= lastPageFetched - 5) {
        console.log('index & lastPageChange at this point: ', index, lastPageFetched);
        console.log('fetch pdf pages while userWantedPage >= lastPageFetched - 5');
        fetchPdfPages(lastPageFetched, index + 10, (lastFetchedPages, lastFetchedIndex) => {
          // setCurrentPage(index);
          setTimeout(() => {
            swiper1Ref.current.slideTo(index - 1);
          }, 500);
        });
      } else {
        swiper1Ref.current.slideTo(index - 1);
      }
    } else {
      // setCurrentPage(0);
      // swiper1Ref.current.slideTo(0);
      toast.error('Please enter a valid number!');
    }
  };

  const onSlideChange = (event) => {
    setCurrentPage(event?.activeIndex + 1 ?? 0);
  };
  const onThumbSwiperSlideChange = (event) => {
    // console.log('onThumbSwiperSlideChange', event);
    if (event.isEnd) {
      fetchPdfPages(lastPageFetched, BaseLimit);
    }
  };
  const handleLeftSwipe = () => {
    swiper1Ref.current.slideTo(currentPage - 2);
  };
  const handleRightSwipe = () => {
    swiper1Ref.current.slideTo(currentPage);
  };
  return (
    <>
      <div className="d-flex flex-column rounded-4 bg-white d-flex ">
        <div className="flex-shrink-0 d-flex justify-content-between border-1 border-bottom p-md-4 p-3 align-items-center">
          <div className="me-auto d-flex align-items-center gap-3">
            <span>Go to page</span>
            <PageNumberInput
              handlePageChange={handlePageChange}
              currentPage={currentPage}
              disabled={isLoading}
            />
            <span>/</span>
            <span>{totalCount}</span>
          </div>
          <div className="ms-auto d-flex align-items-center gap-3">
            <div
              className="custom-prev icon-size-32 rounded-circle d-inline-flex align-items-center justify-content-center transition rippleEffect clr_v3_icon-btn-1"
              onClick={handleLeftSwipe}
            >
              <i className="flaticon-left-chevron fs-1"></i>
            </div>
            <div
              className="custom-next icon-size-32 rounded-circle d-inline-flex align-items-center justify-content-center transition rippleEffect clr_v3_icon-btn-1"
              onClick={handleRightSwipe}
            >
              <i className="flaticon-chevron fs-1"></i>
            </div>

            <div
              className="icon-size-32 rounded-circle d-inline-flex align-items-center justify-content-center transition rippleEffect clr_v3_icon-btn-1"
              onClick={toggleExpansion}
            >
              <HamburgerMenu />
            </div>
          </div>
        </div>
        <div className="flex-grow-1 gap-4 p-md-4 p-3 position-relative pdf-swiper-container flex-md-row-reverse flex-column overflow-hidden">
          <div className="flex-grow-1 pdf-swiper-big-container" id="pdf-swiper">
            {isLoading && (
              <div className="position-absolute start-50 mt-4 z-3 translate-middle-x">
                <Spinner variant="black" />
              </div>
            )}

            {/* position-absolute start-50 mt-4 translate-middle-x z-3 */}
            <Swiper
              className="pdf-swiper-big"
              key={'first'}
              onSlideChange={onSlideChange}
              onSwiper={(swiper) => {
                if (swiper1Ref.current === null) {
                  swiper1Ref.current = swiper;
                }
              }}
              zoom
              preloadImages={false}
              spaceBetween={10}
              slidesPerView={1}
              // freeMode={true}
              lazy={true}
              // navigation={{
              //   prevEl: '.custom-prev',
              //   nextEl: '.custom-next'
              // }}
              thumbs={{
                swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
              }}
              modules={[Zoom, Navigation, Thumbs, Controller, Lazy]}
            >
              {pdfImages.map((image, index) => (
                <SwiperSlide key={'mainkey' + index}>
                  <div className="swiper-zoom-container">
                    <img
                      src={image?.page_url?.replace(
                        googleStorageBaseUrl,
                        process.env.REACT_APP_IMAGE_CDN_ENDPOINT
                      )}
                      className="h-auto w-auto mw-100 mh-100"
                    />
                  </div>
                </SwiperSlide>
              ))}{' '}
            </Swiper>
          </div>
          <div
            className={`pdf-swiper-small-container bg-white flex-shrink-0 p-3 z-2 ${
              isSidebarOpen ? 'show' : ''
            }`}
          >
            <Swiper
              className="h-100 pdf-swiper-small"
              onSlideChange={onThumbSwiperSlideChange}
              key={'second'}
              loop={false}
              spaceBetween={10}
              slidesPerView={4}
              // watchSlidesProgress={true}
              touchRatio={0.2}
              preloadImages={false}
              freeMode={true}
              direction={'vertical'}
              lazy={true}
              slideToClickedSlide={true}
              onSwiper={setThumbsSwiper}
              navigation={false}
              mousewheel={true}
              modules={[Mousewheel, Navigation, Thumbs, Controller, FreeMode, Lazy]}
            >
              {pdfImages.map((image, index) => (
                <SwiperSlide
                  className={`border border-2 transition rounded-3 overflow-hidden ${
                    currentPage === index + 1 ? 'border-primary' : 'border-light'
                  }`}
                  key={'subkey' + index}
                >
                  <div className="d-flex align-items-center justify-content-center w-100 h-100 overflow-hidden">
                    <img
                      src={image?.page_url?.replace(
                        googleStorageBaseUrl,
                        process.env.REACT_APP_IMAGE_CDN_ENDPOINT
                      )}
                      className={`h-auto w-auto mw-100 mh-100`}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
}

function PageNumberInput({ handlePageChange, currentPage, disabled }) {
  const [input, setInput] = useState(currentPage);
  const [show, setShow] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => {
    setInput(currentPage);
  }, [currentPage]);
  // useEffect(() => {
  //   !show && inputRef.current.blur()
  // }, [show])
  const handleInput = (e) => {
    setInput(e.target.value);
  };
  const onHide = () => {
    setShow(false);
  };
  const onSubmitClick = () => {
    handlePageChange(input);

    onHide();
  };
  const handleFocusInput = (e) => {
    setShow(true);
  };
  return (
    <>
      <div className="d-flex">
        {/* create a input to directly go to a page */}
        <Form.Control
          className="text-center goto-page-input py-2 px-2 rounded-1 border-1"
          type="number"
          ref={inputRef}
          disabled={disabled}
          value={currentPage}
          onClick={handleFocusInput}
          readOnly
        />
      </div>
      <Modal className="centerModal" size="md" centered show={show} onHide={onHide}>
        <Modal.Header className="position-relative border-0 p-4 mb-1">
          <Modal.Title className="fs-4 text-black fw-semibold">
            Enter Page<span className="text-danger">*</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form>
            <div className="w-100 centerModalFrm">
              <div className="row mt-n4">
                <FloatingLabel className="mt-4 px-0" controlId="floatingInput" label="Page No">
                  <Form.Control
                    className="fs-4 userProfile_nameModal_yourName"
                    type="number"
                    placeholder="Page No"
                    value={input}
                    onChange={handleInput}
                  />
                </FloatingLabel>
                <div className="mt-4 d-flex flex-wrap centerModalBttns px-0">
                  <button
                    className="col fs-4 btn btn-danger py-3 px-4 userProfile_nameModal_cancel"
                    type="button"
                    onClick={onHide}
                    aria-label="Cancel"
                  >
                    Cancel
                  </button>
                  <button
                    className="col fs-4 btn btn-primary py-3 px-4 userProfile_nameModal_submit"
                    type="button"
                    onClick={onSubmitClick}
                    aria-label="Submit"
                  >
                    Go
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
function HamburgerMenu() {
  return (
    <svg
      className="hb position-relative z-3"
      viewBox="0 0 10 10"
      stroke="#525252"
      strokeWidth=".64"
      fill="rgba(0,0,0,0)"
      strokeLinecap="round"
      style={{
        height: '24px',
        width: '24px'
      }}
    >
      <path d="M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7">
        <animate
          dur="0.2s"
          attributeName="d"
          values="M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7;M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7"
          fill="freeze"
          begin="start.begin"
        />
        <animate
          dur="0.2s"
          attributeName="d"
          values="M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7;M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7"
          fill="freeze"
          begin="reverse.begin"
        />
      </path>
      <rect width="10" height="10" stroke="none">
        <animate dur="2s" id="reverse" attributeName="width" begin="click" />
      </rect>
      <rect width="10" height="10" stroke="none">
        <animate
          dur="0.001s"
          id="start"
          attributeName="width"
          values="10;0"
          fill="freeze"
          begin="click"
        />
        <animate
          dur="0.001s"
          attributeName="width"
          values="0;10"
          fill="freeze"
          begin="reverse.begin"
        />
      </rect>
    </svg>
  );
}
